import FileSaver from "file-saver";
import XLSX from "xlsx";
import axios from 'axios';
class exportTable {
    pageList = []
    tableHeader = []
    tableWrap = ''
    columnKey = {}
    templatesfun = {}
    pageSize = 500
    params = {}
    url = ''
    constructor(app){
        this.appVue = app
    }
    /* 初始化表格基本所需基本变量信息 */
    initTable(options){
        this.params = options.params
        this.pages = options.total > 0 ? Math.ceil(options.total/this.pageSize) : 0
        this.url = options.url
        this.tableHeader = []
        this.columnKey = {}
        options.tableHeader.forEach((item)=>{
            this.tableHeader.push(item.label)
            this.columnKey[item.prop] = item.prop
            if(item.templateStr) { // 有些字段需要被加工
                this.templatesfun[item.prop] = item.templateStr
            }
        })
    }
    exporTable(exportAfter){
        this.fragment = document.createDocumentFragment()
        this.$tableWrap = $(`<table cellspacing="0" cellpadding="0" border="0"></table>`)
        /* 1.创建表头 */
        this.creatTableHeader()
        /* 2.创建表格内容 */
        this.createTableContent(()=>{
            exportAfter() // 表格导出完以后的回调。对外提供的接口
            /* 3. 将表格装进去 */
            $(this.fragment).append(this.$tableWrap)
            /* 最后将内容放置到 $('.export-table-xls') 中*/
            $('.export-table-xls').append($(this.fragment))
            this.outputExcel() // 导入表格
        })
    }
    /* 创建表头 */
    creatTableHeader(){
        let $theadWrap = $('<thead>')
        let $theadTrWrap = $('<tr>')

        this.tableHeader.forEach((val)=>{
            let th = $('<th></th>')
            th.html(val)
            $theadTrWrap.append(th)
        })

        $theadWrap.append($theadTrWrap)
        this.$tableWrap.append($theadWrap)
    }
    /* 创建表身子 */
    createTableContent(callback){
        /* 小于0 代表没数据 */
        if(this.pages <=0 ){
            callback()
            return;
        }
        let sendList = []
        if(this.pages > 30){
            this.appVue.$notify({
                title: '警告',
                message: '数据量导出过多，请联系管理员！',
                type: 'warning'
            });
            return;
        }
        for(let i=0; i < this.pages; i++){
            let num = i+1
            this.pageList[i] = num
            sendList.push(this.postAjax(num))
        }
        
        /* 
            两个请求执行完成后，才执行axios.spread()中的函数，
            且axios.spread()回调函数的的返回值中的请求结果的顺序和请求的顺序一致 
        */
        axios.all(sendList).then(axios.spread((...res) => {
            console.log('所有请求完成')

            let resultSet = []
            res.forEach(item=>{
                if(item.data.result && item.data.result[0]){
                    resultSet = resultSet.concat(item.data.result[0].data)
                }
            })

            this.createTr(resultSet) // 创建行

            callback()
        })).catch((e)=>{
            console.log('导出失败')
            callback()
        })
    }
    createTr(resultSet){
        let $tbody = $('<tbody>')
        if(resultSet.length > 0) {
            resultSet.forEach((item) =>{
                let $tr = $('<tr>')
                $tbody.append($tr)
                for(let key in this.columnKey){
                    if(Object.keys(item).includes(key)){
                        let $td = $('<td>')
                        if(this.templatesfun[key]){  // 证明对应的key需要加工一下
                            let htmlstr = this.templatesfun[key](item)
                            $td.html(htmlstr)
                        }else{
                            $td.html(item[key])
                        }
                        
                        $tr.append($td)
                    }
                }
            })
        }
        this.$tableWrap.append($tbody)
    }
    postAjax(pageIndex){
        this.params.pageIndex = pageIndex
        this.params.pageSize = this.pageSize
        return this.appVue.$axios.post(this.url,{...this.params})
    }
    
     // 导出表格所用
    outputExcel() {
        // 设置当前日期
        let time = new Date();
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        let name = "统计表格" + year + "" + month + "" + day;
        //  .table要导出的是哪一个表格
        var wb = XLSX.utils.table_to_book(document.querySelector(".export-table-xls"));
        /* get binary string as output */
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
        });
        try {
            //  name+'.xlsx'表示导出的excel表格名字
            FileSaver.saveAs(
                new Blob([wbout], { type: "application/octet-stream" }),
                name + ".xlsx"
            );
            $(".export-table-xls").empty()
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
    }
}

export default {
    install(Vue) {
        Vue.prototype.expTable = new exportTable(Vue.prototype)
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/customExportTable.js